import { Badge } from "react-bootstrap";
import { TipoServicio } from "../../services/ventasServicios";

function ServicioBadge({ servicio }: { servicio: TipoServicio }) {
  return (
    <Badge
      key={servicio}
      bg={computeBadgeColor(servicio)}
      style={{ margin: "2px" }}
    >
      {computeBadgeLabel(servicio)}
    </Badge>
  );
}

const computeBadgeColor = (tipoServicio: TipoServicio) => {
  switch (tipoServicio) {
    case "GUARDERIA":
      return "primary";
    case "HOTEL":
      return "secondary";
    case "ENTRENAMIENTO":
      return "success";
    case "SPA":
      return "warning";
    case "TRANSPORTE":
      return "info";
    default:
      return "dark";
  }
};

const computeBadgeLabel = (tipoServicio: TipoServicio) => {
  switch (tipoServicio) {
    case "GUARDERIA":
      return "GUAR";
    case "HOTEL":
      return "HOT";
    case "ENTRENAMIENTO":
      return "ENTR";
    case "SPA":
      return "SPA";
    case "TRANSPORTE":
      return "TRANS";
    default:
      return "";
  }
};

export default ServicioBadge;
